import React from 'react';
import { HiDownload } from 'react-icons/hi';

import * as S from './styles';
import Modal from 'components/Modal';
import { TrainingProps } from 'types/TrainingProps';
import MobileBody from 'components/MobileBody';
import { formatDateBR } from 'utils/functions';
import { returnThumbYoutube } from 'utils/returnJSXs';

interface PreviewTrainingProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	trainingToView: TrainingProps | null;
	resetFunction: () => void;
}

export default function PreviewTraining({
	isOpenForm,
	resetFunction,
	setIsOpenForm,
	trainingToView
}: PreviewTrainingProps) {
	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetFunction();
			}}
			title={`${trainingToView?.title}`}
			buttonClose={false}
		>
			<S.container>
				<MobileBody
					backgroundColor="#F5F5F5"
					showHeaderPhone={false}
					heightContentPhone="100%"
				>
					<S.centralize>
						<S.boxApp>
							<S.date>{formatDateBR(trainingToView?.date || '')}</S.date>
							<S.title>{trainingToView?.title}</S.title>
							<S.description
								dangerouslySetInnerHTML={{
									__html: trainingToView?.description || ''
								}}
							/>
							<S.img>
								{returnThumbYoutube(
									trainingToView?.urlVideo || '',
									trainingToView?.title || ''
								)}
							</S.img>
							<S.title>{trainingToView?.content.title}</S.title>
							<S.description
								dangerouslySetInnerHTML={{
									__html: trainingToView?.content.description || ''
								}}
							/>

							<S.button>
								<button>
									Baixar PDF <HiDownload />
								</button>
							</S.button>
						</S.boxApp>
					</S.centralize>
				</MobileBody>
			</S.container>
		</Modal>
	);
}
